import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "activity-update"
};
const _hoisted_2 = {
  class: "main"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("超值换购");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("活动规则设置");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("单品满数量赠");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("满金额赠");

const _hoisted_8 = {
  key: 0,
  class: "group-extra"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "单笔订单金额满", -1);

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_11 = {
  key: 1,
  class: "group-extra"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "活动品种组合满", -1);

const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_14 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px"
  }
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "至", -1);

const _hoisted_16 = {
  class: "supplier-publisher-wrap"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("全品类");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("部分商品");

const _hoisted_19 = /*#__PURE__*/_createTextVNode("单商品满数量自主换购");

const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "rule-tip"
}, "单品满数量后自主选择换购商品及换购数量（支持阶梯）", -1);

const _hoisted_21 = /*#__PURE__*/_createTextVNode("单商品满数量自动换购");

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "rule-tip"
}, "单商品满数量后自动增加换购商品及换购数量，不可修改", -1);

const _hoisted_23 = /*#__PURE__*/_createTextVNode("多商品任一满数量自主换购");

const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "rule-tip"
}, "多商品任一满数量后自主选择换购商品及换购数量           ", -1);

const _hoisted_25 = /*#__PURE__*/_createTextVNode("全品类");

const _hoisted_26 = {
  class: "form-table"
};
const _hoisted_27 = {
  key: 0,
  class: "toolbox"
};
const _hoisted_28 = {
  class: "flex"
};

const _hoisted_29 = /*#__PURE__*/_createTextVNode("添加商品");

const _hoisted_30 = /*#__PURE__*/_createTextVNode("批量设置活动规则 ");

const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_33 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_34 = {
  key: 2,
  class: "total-count"
};
const _hoisted_35 = {
  class: "form-table"
};
const _hoisted_36 = {
  class: "toolbox"
};
const _hoisted_37 = {
  class: "flex"
};

const _hoisted_38 = /*#__PURE__*/_createTextVNode("添加商品");

const _hoisted_39 = {
  key: 2,
  class: "trade-enablesuperpositon"
};

const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "赠品叠加：", -1);

const _hoisted_41 = /*#__PURE__*/_createTextVNode("是");

const _hoisted_42 = /*#__PURE__*/_createTextVNode("否");

const _hoisted_43 = {
  key: 0
};

const _hoisted_44 = /*#__PURE__*/_createTextVNode("批量设置换购价");

const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_47 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_48 = {
  key: 1,
  class: "total-count"
};
const _hoisted_49 = {
  class: "form-table",
  style: {
    "overflow-x": "auto"
  }
};
const _hoisted_50 = {
  class: "toolbox",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_51 = {
  class: "rule-options"
};
const _hoisted_52 = {
  class: "rule-option-row"
};

const _hoisted_53 = /*#__PURE__*/_createTextVNode("不支持倍数叠加");

const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 支持倍数叠加");

const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", {
  class: "rule-tip"
}, "参与活动商品购买数量为门槛数量倍数时，换购数量成倍增长", -1);

const _hoisted_56 = {
  class: "form-table",
  style: {
    "overflow-x": "auto"
  }
};
const _hoisted_57 = {
  class: "toolbox",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_58 = {
  class: "rule-options"
};
const _hoisted_59 = {
  class: "rule-option-row enable-remain-row"
};

const _hoisted_60 = /*#__PURE__*/_createTextVNode("不支持结余");

const _hoisted_61 = /*#__PURE__*/_createTextVNode("支持结余");

const _hoisted_62 = {
  class: "remain-valid-config"
};

const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", {
  class: "remain-valid-bracket"
}, "（", -1);

const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", {
  class: "remain-valid-label"
}, "活动结束后结余可继续购买", -1);

const _hoisted_65 = /*#__PURE__*/_createTextVNode("否");

const _hoisted_66 = {
  class: "remain-valid-yes-inner"
};

const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 是 ");

const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", {
  class: "remain-valid-bracket"
}, "）", -1);

const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", {
  class: "rule-tip-bracket"
}, "（每单未换购完结余数量累加给业务员，可由业务员在后续订单中增加结余数量换购）", -1);

const _hoisted_70 = {
  class: "rule-option-row"
};

const _hoisted_71 = /*#__PURE__*/_createTextVNode("不支持倍数叠加");

const _hoisted_72 = /*#__PURE__*/_createTextVNode(" 支持倍数叠加");

const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", {
  class: "rule-tip"
}, "参与活动商品购买数量为门槛数量倍数时，换购数量成倍增长", -1);

const _hoisted_74 = /*#__PURE__*/_createTextVNode("其他活动品金额/运费/运输保险费不参与计算 ");

const _hoisted_75 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "row"
  }
};

const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-right": "10px"
  }
}, "价格计算标准", -1);

const _hoisted_77 = /*#__PURE__*/_createTextVNode("销售价");

const _hoisted_78 = /*#__PURE__*/_createTextVNode("进货价(预付)");

const _hoisted_79 = {
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "当多个换购品仅支持部分参与时不支持设置多换购品限购总数。", -1);

const _hoisted_81 = {
  key: 0
};

const _hoisted_82 = /*#__PURE__*/_createTextVNode("第 ");

const _hoisted_83 = {
  class: "ladder-index"
};

const _hoisted_84 = /*#__PURE__*/_createTextVNode(" 阶梯");

const _hoisted_85 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};

const _hoisted_86 = /*#__PURE__*/_createTextVNode("无门槛");

const _hoisted_87 = /*#__PURE__*/_createTextVNode("主品/卖品加购");

const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", null, "满", -1);

const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_98 = /*#__PURE__*/_createTextVNode(" 新增阶梯 ");

const _hoisted_99 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_100 = /*#__PURE__*/_createTextVNode("全部可选");

const _hoisted_101 = /*#__PURE__*/_createTextVNode("任选数量");

const _hoisted_102 = {
  key: 0,
  class: "group-extra"
};

const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", null, "换购商品任", -1);

const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", null, "种", -1);

const _hoisted_105 = {
  key: 0,
  class: "footer"
};

const _hoisted_106 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_107 = /*#__PURE__*/_createTextVNode("提交并再次新建");

const _hoisted_108 = /*#__PURE__*/_createTextVNode("提交");

const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", null, "盒", -1);

const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_112 = {
  style: {
    "text-align": "right",
    "padding-top": "10px"
  }
};

const _hoisted_113 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_114 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_115 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_116 = /*#__PURE__*/_createTextVNode("确定");

import { reactive, onMounted, computed, ref, nextTick, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { activityBuygiveUpdate, getActivityBuygiveInfo, getActivityInfoByProdNo } from '@/request';
import { arrayRemoveRepeatByProp, isNullOrDefined } from '@/utils';
import VanInputSelect from '@/components/input/input-select.vue';
import BranchModal from './components/branch-modal.vue';
import SupplierModal from './components/muti-supplier-modal.vue';
import MerchandiseModal from './components/merchandise-modal-v2.vue';
import { QuestionFilled } from '@element-plus/icons-vue';
export default {
  name: 'activity-update',
  props: {
    embedMode: {
      type: Boolean,
      default: false
    },
    embedSnapshot: {
      type: Object,
      default: null
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    let {
      pageType = 'create'
    } = route.query;
    onMounted(() => {
      if (props.embedMode) {
        return;
      }

      switch (pageType) {
        case 'update':
        case 'view':
        case 'copy':
          getDetail();
          break;

        default:
          break;
      }
    });
    const pageTitle = {
      create: '新建',
      update: '编辑',
      view: '查看',
      copy: '复制'
    };
    const updateDisabled = computed(() => props.embedMode || pageType === 'view'); // 是否为进行中活动的编辑模式

    const isProgressEdit = computed(() => !props.embedMode && pageType === 'update' && Number(route.query.activityStatus) === 2); // 编辑场景不允许切换“是否支持结余”

    const enableRemainDisabled = computed(() => updateDisabled.value || !props.embedMode && pageType === 'update'); // 受限字段的禁用计算（查看模式全禁，进行中编辑按规则禁）

    const activityNameDisabled = computed(() => updateDisabled.value || isProgressEdit.value);
    const activityTypeDisabled = computed(() => updateDisabled.value || isProgressEdit.value);
    const branchDisabled = computed(() => updateDisabled.value || isProgressEdit.value);
    const activityRuleDisabled = computed(() => updateDisabled.value || isProgressEdit.value && formData.activityType === activityTypes['满数量赠']);
    const selectMerchandiseTypeDisabled = computed(() => updateDisabled.value || isProgressEdit.value && formData.activityType === activityTypes['全品类满金额赠']); // 开始时间：查看模式或进行中编辑时禁用；结束时间：仅查看模式禁用

    const activityStartTimeDisabled = computed(() => updateDisabled.value || isProgressEdit.value);
    const activityEndTimeDisabled = computed(() => updateDisabled.value); // 拆分 activityTimeList 数组为两个可写 computed，供双 picker 绑定

    const activityStartTime = computed({
      get: () => {
        var _formData$activityTim, _formData$activityTim2;

        return (_formData$activityTim = (_formData$activityTim2 = formData.activityTimeList) === null || _formData$activityTim2 === void 0 ? void 0 : _formData$activityTim2[0]) !== null && _formData$activityTim !== void 0 ? _formData$activityTim : null;
      },
      set: val => {
        var _formData$activityTim3, _formData$activityTim4;

        formData.activityTimeList = [val, (_formData$activityTim3 = (_formData$activityTim4 = formData.activityTimeList) === null || _formData$activityTim4 === void 0 ? void 0 : _formData$activityTim4[1]) !== null && _formData$activityTim3 !== void 0 ? _formData$activityTim3 : null];
      }
    });
    const activityEndTime = computed({
      get: () => {
        var _formData$activityTim5, _formData$activityTim6;

        return (_formData$activityTim5 = (_formData$activityTim6 = formData.activityTimeList) === null || _formData$activityTim6 === void 0 ? void 0 : _formData$activityTim6[1]) !== null && _formData$activityTim5 !== void 0 ? _formData$activityTim5 : null;
      },
      set: val => {
        var _formData$activityTim7, _formData$activityTim8;

        formData.activityTimeList = [(_formData$activityTim7 = (_formData$activityTim8 = formData.activityTimeList) === null || _formData$activityTim8 === void 0 ? void 0 : _formData$activityTim8[0]) !== null && _formData$activityTim7 !== void 0 ? _formData$activityTim7 : null, val];
      }
    });

    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    const activityTypes = {
      满数量赠: 'SL',
      满金额赠: 'JE',
      组合满数量赠: 'ZHSL',
      全品类满金额赠: 'QPL'
    };
    const activityRuleTypes = {
      多商品任一满数量自主换购: 1,
      单商品满数量自动换购: 2,
      单商品满数量自主换购: 3
    };

    const activityTimeDisabledDate = date => {
      let oneDayTimeStamp = 24 * 60 * 60 * 1000;
      return new Date(date).getTime() + oneDayTimeStamp < Date.now();
    };

    const form = ref();

    class FormDataTpl {
      constructor() {
        this.activityId = undefined;
        this.activityName = '';
        this.activityType = 'SL';
        this.activityTimeList = [];
        this.orderAmount = undefined;
        this.supplierInfoVo = {
          supplierId: undefined,
          supplierName: ''
        };
        this.branchInfoVo = {
          branchId: undefined,
          branchName: ''
        };
        this.activityRule = 3;
        this.activityMerchandiseInfoList = [];
        this.tradeMerchandiseInfoList = [];
        this.tradeRule = 1;
        this.tradeQuantity = undefined;
        this.enableSuperposition = undefined; // 倍数叠加：0 不叠加 1 叠加，新建默认不选

        this.tradeMerchandiseQuantity = 0;
        this.merchandiseQuantity = undefined; // 组合满数量赠 盒数

        this.ladderRuleList = [{
          // 阶梯换购规则列表
          thresholdQuantityRadio: 0,
          thresholdQuantity: undefined,
          // 门槛数量-空为无门槛(主品用)
          requireQuantity: undefined,
          // 活动规则(满多少盒)
          merchandiseLimitQuantity: undefined,
          // 多换购品限购总数(主品用)
          ruleDetails: [] // 换购规则明细

        }];
        this.enableRemain = undefined; // 结余赠送：0-不支持 1-支持，新建默认不选

        this.remainValidType = 1; // 活动结束后结余可继续购买:1-否；2-是

        this.remainValidStatus = 1; // 结余商品效期:1-长期有效；2-指定时间有效

        this.remainValidEndtime = undefined;
        this.enableUnCalculate = 1;
        this.selectMerchandiseProdNos = [];
        this.prePaymentType = 1; // 价格计算标准 1=销售价,2=进货价(预付)

        this.selectMerchandiseType = 1; // 活动商品类型:1-全品类；2-部分商品
      }

    }

    const formData = reactive(new FormDataTpl());
    const formRules = {
      activityName: [{
        required: true,
        message: '请填写活动名称',
        trigger: 'blur'
      }],
      activityTimeList: [{
        required: true,
        message: '请选择活动时间',
        trigger: 'submit'
      }],
      activityType: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (isNullOrDefined(value)) {
            callback(new Error('请选择活动类型'));
          } else if (value === activityTypes['满金额赠']) {
            isNullOrDefined(formData.orderAmount) && callback(new Error('请填写满赠订单金额'));
          } else if (value === activityTypes['组合满数量赠']) {
            isNullOrDefined(formData.merchandiseQuantity) && callback(new Error('请填写组合满数量盒数'));
          }

          callback();
        }
      }],
      supplierInfoVo: [{
        required: true,
        trigger: '',
        validator: (rule, value, callback) => {
          if (Boolean(value.supplierId) === false) {
            callback(new Error('请选择活动发起方'));
          }

          callback();
        }
      }],
      branchInfoVo: [{
        required: true,
        trigger: '',
        validator: (rule, value, callback) => {
          if (Boolean(value.branchId) === false) {
            callback(new Error('请选择发货方'));
          }

          callback();
        }
      }],
      selectMerchandiseType: [{
        required: true,
        trigger: 'change',
        validator: (rule, value, callback) => {
          if (formData.activityType === activityTypes['全品类满金额赠'] && isNullOrDefined(value)) {
            callback(new Error('请选择活动商品类型'));
          }

          callback();
        }
      }],
      activityRule: [{
        required: true,
        message: '请选择活动规则',
        trigger: 'change'
      }],
      activityMerchandiseInfoList: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (formData.activityType === activityTypes['全品类满金额赠'] && formData.selectMerchandiseType === 1) {
            callback();
            return;
          }

          if (value.length === 0) {
            callback(new Error('请选择活动商品'));
          }

          let valid = value.every(item => item.requireQuantity);

          if (!valid && formData.activityType === activityTypes['满数量赠'] && formData.activityRule !== activityRuleTypes['单商品满数量自主换购']) {
            callback(new Error('请填写活动商品规则'));
          }

          callback();
        }
      }],
      tradeMerchandiseInfoList: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (value.length === 0) {
            callback(new Error('请选择换购商品'));
          }

          let valid = value.every(item => item.tradePrice && item.tradeQuantity);

          if (!valid && formData.activityRule !== activityRuleTypes['单商品满数量自主换购']) {
            callback(new Error('请填写换购商品规则'));
          }

          callback();
        }
      }],
      tradeRule: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          let {
            activityRule,
            tradeRule,
            tradeQuantity,
            tradeMerchandiseInfoList
          } = formData;

          if (activityRule === activityRuleTypes['多商品任一满数量自主换购'] && tradeRule === 2) {
            if (isNullOrDefined(tradeQuantity) || tradeQuantity === 0) {
              callback(new Error('请填写换购数量'));
            } else if (tradeQuantity > tradeMerchandiseInfoList.length) {
              callback(new Error('换购数量不得超过换购商品数量'));
            }
          }

          callback();
        }
      }],
      ladderRuleList: [{
        trigger: 'submit',
        validator: (rule, value, callback) => {
          const needLadderRuleOptions = formData.activityRule === activityRuleTypes['单商品满数量自主换购'] && formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['全品类满金额赠'] || formData.activityType === activityTypes['满金额赠'];

          if (needLadderRuleOptions) {
            if (formData.activityRule === activityRuleTypes['单商品满数量自主换购'] && formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['全品类满金额赠']) {
              if (formData.enableRemain !== 0 && formData.enableRemain !== 1) {
                callback(new Error('请选择是否支持结余'));
                return;
              }
            }

            if (formData.enableSuperposition !== 0 && formData.enableSuperposition !== 1) {
              callback(new Error('请选择是否支持倍数叠加'));
              return;
            }
          }

          if (formData.activityRule === activityRuleTypes['单商品满数量自主换购']) {
            // 检查每个阶梯规则是否填写完整
            const valid = value.every(rule => {
              // 检查活动规则是否填写
              if (!rule.requireQuantity) return false; // 检查每个换购商品的规则是否填写
              // return rule.ruleDetails.every(detail => 
              // detail.tradeQuantity && detail.tradePrice
              // );

              return true;
            });

            if (!valid) {
              callback(new Error('请完善换购规则信息'));
              return;
            } // 检查阶梯规则的递增关系


            for (let i = 1; i < value.length; i++) {
              const prevRule = value[i - 1];
              const currentRule = value[i]; // 检查活动规则数量是否递增

              if (currentRule.thresholdQuantity === prevRule.thresholdQuantity && currentRule.requireQuantity <= prevRule.requireQuantity) {
                callback(new Error(`第${i + 1}阶梯的活动规则数量必须大于第${i}阶梯`));
                return;
              }

              const curMerchandiseLimitQuantity = currentRule.merchandiseLimitQuantity; // 检查每个换购商品的数量是否递增

              for (let j = 0; j < currentRule.ruleDetails.length; j++) {
                const prevDetail = prevRule.ruleDetails[j];
                const currentDetail = currentRule.ruleDetails[j]; // if (isNullOrDefined(curMerchandiseLimitQuantity) && currentDetail.tradeQuantity <= prevDetail.tradeQuantity && currentDetail.tradeQuantity > 0 && prevDetail.tradeQuantity > 0) {
                //     const prodName = formData.tradeMerchandiseInfoList[j]?.prodName;
                //     callback(new Error(`第${i + 1}阶梯的${prodName}换购数量必须大于第${i}阶梯`));
                //     return;
                // }
              }
            }
          }

          callback();
        }
      }]
    }; // 活动详情

    const loading = ref(false);

    function applyDetailData(data) {
      if (!data) {
        return;
      }

      let {
        activityId,
        activityName,
        activityType,
        activityStartTime,
        activityEndTime,
        orderAmount,
        supplierInfoVo,
        branchInfoVo,
        activityRule,
        activityMerchandiseInfoList,
        tradeMerchandiseInfoList,
        tradeRule,
        tradeQuantity,
        enableSuperposition,
        tradeMerchandiseQuantity,
        merchandiseQuantity,
        ladderRuleList,
        enableRemain,
        remainValidType,
        remainValidStatus,
        remainValidEndtime,
        selectedSupplierIds,
        prePaymentType,
        selectMerchandiseType
      } = data;
      formData.activityId = activityId;
      formData.activityName = activityName;
      formData.activityType = activityType;
      formData.activityTimeList = [activityStartTime, activityEndTime];
      formData.supplierInfoVo = supplierInfoVo;
      formData.branchInfoVo = branchInfoVo;
      formData.activityRule = activityRule;
      formData.selectMerchandiseType = selectMerchandiseType || 1;
      formData.activityMerchandiseInfoList = activityMerchandiseInfoList;
      formData.tradeMerchandiseInfoList = tradeMerchandiseInfoList;
      formData.enableSuperposition = enableSuperposition !== null && enableSuperposition !== void 0 ? enableSuperposition : undefined;
      formData.tradeMerchandiseQuantity = tradeMerchandiseQuantity;
      formData.merchandiseQuantity = merchandiseQuantity;
      formData.ladderRuleList = ladderRuleList;

      if (activityType === activityTypes['满金额赠']) {
        formData.orderAmount = orderAmount;
      }

      if (activityRule === activityRuleTypes['多商品任一满数量自主换购']) {
        formData.tradeRule = tradeRule;

        if (tradeRule === 2) {
          formData.tradeQuantity = tradeQuantity;
        }
      }

      formData.enableRemain = enableRemain !== null && enableRemain !== void 0 ? enableRemain : undefined;
      formData.remainValidType = remainValidType !== null && remainValidType !== void 0 ? remainValidType : 1;
      formData.remainValidStatus = remainValidStatus !== null && remainValidStatus !== void 0 ? remainValidStatus : 1;
      formData.remainValidEndtime = remainValidEndtime;
      formData.enableUnCalculate = 1;
      supplierModal.selectedSupplierIds = selectedSupplierIds;
      formData.selectMerchandiseProdNos = (tradeMerchandiseInfoList || []).map(item => item.prodNo);
      formData.prePaymentType = prePaymentType;
    }

    function getDetail() {
      loading.value = true;
      getActivityBuygiveInfo({
        activityId: route.query.activityId
      }).then(res => {
        applyDetailData(res.data);
      }).finally(() => {
        loading.value = false;
      });
    }
    /**
     * 活动发起方，
     */


    const branchModal = reactive({
      visible: false
    });
    const supplierModal = reactive({
      visible: false,
      selectedSupplierIds: []
    });
    watch(() => props.embedSnapshot, val => {
      if (props.embedMode && val) {
        applyDetailData(val);
      }
    }, {
      immediate: true
    });
    const supplierPublisherCount = computed(() => {
      var _supplierModal$select, _formData$supplierInf;

      if ((_supplierModal$select = supplierModal.selectedSupplierIds) !== null && _supplierModal$select !== void 0 && _supplierModal$select.length) {
        return supplierModal.selectedSupplierIds.length;
      }

      const supplierId = (_formData$supplierInf = formData.supplierInfoVo) === null || _formData$supplierInf === void 0 ? void 0 : _formData$supplierInf.supplierId;

      if (!supplierId) {
        return 0;
      }

      return String(supplierId).split(',').filter(id => id !== undefined && id !== '').length;
    });
    const supplierFilterIds = computed(() => {
      var _supplierModal$select2, _formData$supplierInf2;

      if ((_supplierModal$select2 = supplierModal.selectedSupplierIds) !== null && _supplierModal$select2 !== void 0 && _supplierModal$select2.length) {
        return supplierModal.selectedSupplierIds.join(',');
      }

      const supplierId = (_formData$supplierInf2 = formData.supplierInfoVo) === null || _formData$supplierInf2 === void 0 ? void 0 : _formData$supplierInf2.supplierId;
      return supplierId ? String(supplierId) : '';
    });

    function openSupplierModalHandle() {
      supplierModal.visible = true;
    }

    function selectBranchHandle() {
      if (!formData.supplierInfoVo.supplierId) {
        ElMessage.warning('请先选择活动发起方');
        return false;
      }

      branchModal.visible = true;
    }

    function selectBranchSuccessHandle(branchRow) {
      if (isNullOrDefined(branchRow)) return;
      let {
        branchId,
        branchName
      } = branchRow; // 切换发货方后，清空商品

      if (branchId !== formData.branchInfoVo.branchId) {
        formData.activityMerchandiseInfoList = [];
        formData.tradeMerchandiseInfoList = [];
      }

      formData.branchInfoVo = {
        branchId,
        branchName
      };
    }

    function buildActivityConflictCheckParams(extra = {}) {
      const params = _objectSpread({
        buyGiveActivityType: formData.activityType,
        activityStartTime: formData.activityTimeList[0],
        activityEndTime: formData.activityTimeList[1],
        excludeActivityId: pageType === 'update' ? formData.activityId : undefined
      }, extra);

      if (formData.activityType === activityTypes['全品类满金额赠']) {
        params.selectMerchandiseType = formData.selectMerchandiseType;
      }

      return params;
    }

    function selectSupplierSuccessHandle(supplierRows) {
      if (isNullOrDefined(supplierRows)) return;
      let supplierRowsList = supplierRows;
      supplierRowsList.sort((a, b) => a.supplierId - b.supplierId);
      let supplierId = supplierRowsList.map(supplier => supplier.supplierId).join(',');
      let supplierName = supplierRowsList.map(supplier => supplier.supplierName).join(',');
      let branchId = formData.branchInfoVo.branchId;
      let prodNoList = formData.activityMerchandiseInfoList.map(item => item.prodNo);
      let prodNo = prodNoList.join(", ");

      if (formData.activityType === activityTypes['全品类满金额赠'] && formData.selectMerchandiseType === 1) {
        prodNo = "0";
      }

      getActivityInfoByProdNo(buildActivityConflictCheckParams({
        prodNo: prodNo,
        supplierId: supplierId,
        branchId: branchId,
        type: '1'
      })).then(res => {
        if (!res.success) {
          ElMessage.warning(res.msg);
        } else {
          formData.supplierInfoVo = {
            supplierId,
            supplierName
          };
          supplierModal.selectedSupplierIds = supplierRowsList.map(supplier => supplier.supplierId);
        }
      }).finally(() => {});
    }

    function supplierClearHandle() {
      formData.supplierInfoVo = {
        supplierId: undefined
      };
    }

    function branchClearHandle() {
      formData.branchInfoVo = {
        branchId: undefined
      };
    }

    function selectMerchandiseTypeChangeHandle() {
      // 切换活动商品类型后，清空主品，避免“全品类/部分商品”残留数据混用
      formData.activityMerchandiseInfoList = [];
    } // 添加商品


    const merchandiseModal = reactive({
      visible: false,
      merchandiseTypeKey: undefined
    });
    const merchandiseModalCheckType = computed(() => {
      let {
        merchandiseTypeKey
      } = merchandiseModal;
      let {
        activityRule
      } = formData;

      if (formData.activityType === activityTypes['全品类满金额赠'] && formData.selectMerchandiseType === 2 && merchandiseTypeKey === 'activityMerchandiseInfoList') {
        return 'checkbox';
      }

      if ((activityRule === activityRuleTypes['单商品满数量自动换购'] || activityRule === activityRuleTypes['单商品满数量自主换购']) && merchandiseTypeKey === 'activityMerchandiseInfoList') {
        // 单商品满数量自动换购和单商品满数量自主换购模式下,活动商品都需要单选
        return 'radio';
      }

      return 'checkbox';
    });

    function addMerchandiseHandle(merchandiseTypeKey) {
      if (!formData.supplierInfoVo.supplierId || !formData.branchInfoVo.branchId) {
        ElMessage.warning('请先选择活动发起方和发货方');
        return false;
      }

      if (formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] && formData[merchandiseTypeKey].length > 1000) {
        ElMessage.warning('超过最大商品数量1000个，请先删除部分商品');
        return false;
      }

      if (formData.activityRule === activityRuleTypes['单商品满数量自动换购'] && formData[merchandiseTypeKey].length > 50) {
        ElMessage.warning('超过最大商品数量50个，请先删除部分商品');
        return false;
      }

      merchandiseModal.visible = true;
      merchandiseModal.merchandiseTypeKey = merchandiseTypeKey;

      if (merchandiseTypeKey === 'activityMerchandiseInfoList') {
        formData.selectMerchandiseProdNos = [];
      }
    }

    function selectMerchandiseSuccessHandle(merchandiseList) {
      if (merchandiseModal.merchandiseTypeKey === 'activityMerchandiseInfoList') {
        // 校验主品在其他活动里面是否存在
        const prodNoList = merchandiseList.map(item => item.prodNo);
        const prodNo = prodNoList.join(", ");
        const supplierId = formData.supplierInfoVo.supplierId;
        const branchId = formData.branchInfoVo.branchId;
        getActivityInfoByProdNo(buildActivityConflictCheckParams({
          prodNo: prodNo,
          supplierId: supplierId,
          branchId: branchId,
          type: '2'
        })).then(res => {
          if (!res.success) {
            formData.activityMerchandiseInfoList = [];
            ElMessage.warning(res.msg);
            return false;
          }
        }).finally(() => {});
      } // 多商品任一满数量自主换购最大商品数量为1000个，单商品满数量自动换购和单商品满数量自主换购最大活动商品数量为1个


      if ((formData.activityRule === activityRuleTypes['单商品满数量自动换购'] || formData.activityRule === activityRuleTypes['单商品满数量自主换购']) && merchandiseModal.merchandiseTypeKey === 'activityMerchandiseInfoList') {
        if (formData.activityType === activityTypes['全品类满金额赠'] && formData.selectMerchandiseType === 2) {// QPL-部分商品：支持多主品，不走单商品替换逻辑
        } else {
          // 单商品满数量自动换购直接替换原活动商品
          formData.activityMerchandiseInfoList = merchandiseList;
          return true;
        }
      }

      let list = [...formData[merchandiseModal.merchandiseTypeKey], ...merchandiseList];
      let uniqueList = arrayRemoveRepeatByProp(list, 'prodNo');

      if (formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] && uniqueList.length > 1000) {
        ElMessage.warning('超过最大商品数量1000个，请先删除部分商品');
        return false;
      }

      if (formData.activityRule === activityRuleTypes['单商品满数量自动换购'] && uniqueList.length > 50) {
        ElMessage.warning('超过最大商品数量50个，请先删除部分商品');
        return false;
      }

      formData[merchandiseModal.merchandiseTypeKey] = uniqueList.map(item => {
        !item.requireQuantity && (item.requireQuantity = undefined); // 满xx盒

        !item.tradePrice && (item.tradePrice = undefined); // 换购价

        !item.tradeQuantity && (item.tradeQuantity = undefined); // 换购量

        return item;
      }); // 换购商品变更后，同步阶梯规则明细

      if (merchandiseModal.merchandiseTypeKey === 'tradeMerchandiseInfoList' && getNeedLadderRuleOptions()) {
        syncLadderRuleDetailsWithTradeMerchandise();
        formData.tradeMerchandiseQuantity = formData.tradeMerchandiseInfoList.length;
      }

      if (merchandiseModal.merchandiseTypeKey === 'tradeMerchandiseInfoList') {
        const prodNoList = merchandiseList.map(item => item.prodNo);
        formData.selectMerchandiseProdNos = formData.selectMerchandiseProdNos.concat(prodNoList);
      }
    }

    function deleteMerchandiseHandle(merchandiseTypeKey, scope) {
      let {
        prodNo
      } = scope.row;
      let deleteIndex = formData[merchandiseTypeKey].findIndex(v => v.prodNo === prodNo);
      formData[merchandiseTypeKey].splice(deleteIndex, 1);
      formData.tradeMerchandiseQuantity = formData.tradeMerchandiseInfoList.length;

      if (merchandiseTypeKey === 'tradeMerchandiseInfoList' && getNeedLadderRuleOptions()) {
        syncLadderRuleDetailsWithTradeMerchandise();
      }
    }

    function showSubmitValidateError(message) {
      if (!message) {
        return;
      }

      ElMessage.error({
        message,
        duration: 5000,
        showClose: true
      });
    }

    function getNeedLadderRuleOptions() {
      return formData.activityRule === activityRuleTypes['单商品满数量自主换购'] && formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['全品类满金额赠'] || formData.activityType === activityTypes['满金额赠'];
    }

    function syncLadderRuleDetailsWithTradeMerchandise() {
      var _formData$ladderRuleL, _formData$ladderRuleL2;

      if (!formData.tradeMerchandiseInfoList.length) {
        return;
      }

      if (formData.ladderRuleList.length === 0) {
        formData.ladderRuleList = [{
          thresholdQuantityRadio: 0,
          thresholdQuantity: undefined,
          requireQuantity: undefined,
          merchandiseLimitQuantity: undefined,
          ruleDetails: []
        }];
      }

      const firstRulePrices = ((_formData$ladderRuleL = formData.ladderRuleList[0]) === null || _formData$ladderRuleL === void 0 ? void 0 : (_formData$ladderRuleL2 = _formData$ladderRuleL.ruleDetails) === null || _formData$ladderRuleL2 === void 0 ? void 0 : _formData$ladderRuleL2.map(detail => detail === null || detail === void 0 ? void 0 : detail.tradePrice)) || [];
      formData.ladderRuleList = formData.ladderRuleList.map((rule, ruleIndex) => ({
        thresholdQuantityRadio: rule.thresholdQuantityRadio,
        thresholdQuantity: rule.thresholdQuantity,
        requireQuantity: rule.requireQuantity,
        merchandiseLimitQuantity: rule.merchandiseLimitQuantity,
        ruleDetails: formData.tradeMerchandiseInfoList.map((_, index) => {
          var _rule$ruleDetails, _firstRulePrices$inde;

          const existing = (_rule$ruleDetails = rule.ruleDetails) === null || _rule$ruleDetails === void 0 ? void 0 : _rule$ruleDetails[index];
          return {
            tradeQuantity: existing === null || existing === void 0 ? void 0 : existing.tradeQuantity,
            tradePrice: ruleIndex === 0 ? existing === null || existing === void 0 ? void 0 : existing.tradePrice : (_firstRulePrices$inde = firstRulePrices[index]) !== null && _firstRulePrices$inde !== void 0 ? _firstRulePrices$inde : existing === null || existing === void 0 ? void 0 : existing.tradePrice
          };
        })
      }));
    }

    function validateBeforeSubmit() {
      if (!getNeedLadderRuleOptions()) {
        return null;
      }

      const needRemainChoice = formData.activityRule === activityRuleTypes['单商品满数量自主换购'] && formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['全品类满金额赠'];

      if (needRemainChoice && formData.enableRemain !== 0 && formData.enableRemain !== 1) {
        return {
          message: '请选择是否支持结余',
          prop: 'ladderRuleList'
        };
      }

      if (formData.enableSuperposition !== 0 && formData.enableSuperposition !== 1) {
        return {
          message: '请选择是否支持倍数叠加',
          prop: 'ladderRuleList'
        };
      }

      if (formData.enableRemain === 1 && formData.remainValidType === 2 && formData.remainValidStatus === 2) {
        var _formData$activityTim9;

        if (!formData.remainValidEndtime) {
          return {
            message: '请选择结余商品效期截止时间',
            prop: 'ladderRuleList'
          };
        }

        const activityEndTime = (_formData$activityTim9 = formData.activityTimeList) === null || _formData$activityTim9 === void 0 ? void 0 : _formData$activityTim9[1];

        if (activityEndTime && new Date(formData.remainValidEndtime).getTime() <= new Date(activityEndTime).getTime()) {
          return {
            message: '结余效期截止时间须晚于活动结束时间',
            prop: 'ladderRuleList'
          };
        }
      }

      return null;
    } // 校验与提交


    function submit(type) {
      form.value.validate((valid, invalidFields) => {
        if (!valid) {
          var _invalidFields$firstP, _invalidFields$firstP2;

          const props = Object.keys(invalidFields || {});
          const firstProp = props[0];
          const firstMsg = firstProp ? (_invalidFields$firstP = invalidFields[firstProp]) === null || _invalidFields$firstP === void 0 ? void 0 : (_invalidFields$firstP2 = _invalidFields$firstP[0]) === null || _invalidFields$firstP2 === void 0 ? void 0 : _invalidFields$firstP2.message : '';
          showSubmitValidateError(firstMsg || '请完善活动表单必填项');
          return false;
        }

        const bizError = validateBeforeSubmit();

        if (bizError) {
          showSubmitValidateError(bizError.message);
          return false;
        }

        if (pageType === 'update') {
          editRemarkDialog.submitType = type;
          editRemarkDialog.remark = '';
          editRemarkDialog.visible = true;
          return true;
        }

        doSubmit(type);
      });
    }

    function confirmEditRemarkSubmit() {
      var _editRemarkDialog$rem;

      if (submitting.value) {
        return;
      }

      const remark = (_editRemarkDialog$rem = editRemarkDialog.remark) === null || _editRemarkDialog$rem === void 0 ? void 0 : _editRemarkDialog$rem.trim();

      if (!remark) {
        ElMessage.warning('请输入更新备注');
        return;
      }

      editRemarkDialog.visible = false;
      doSubmit(editRemarkDialog.submitType, remark);
    }

    function doSubmit(type, editRemark) {
      if (submitting.value) {
        return;
      }

      submitting.value = true;
      let body = {
        activityId: pageType === 'update' ? formData.activityId : undefined,
        activityName: formData.activityName,
        activityStartTime: formData.activityTimeList[0],
        activityEndTime: formData.activityTimeList[1],
        activityType: formData.activityType,
        supplierInfoVo: {
          supplierIds: supplierFilterIds.value
        },
        branchInfoVo: {
          branchId: formData.branchInfoVo.branchId
        },
        selectMerchandiseType: formData.activityType === activityTypes['全品类满金额赠'] ? formData.selectMerchandiseType : undefined,
        activityRule: formData.activityRule,
        activityMerchandiseInfoList: formData.activityMerchandiseInfoList.map(item => ({
          prodNo: item.prodNo,
          prodName: item.prodName,
          thresholdQuantityRadio: item.thresholdQuantityRadio,
          thresholdQuantity: item.thresholdQuantity,
          requireQuantity: item.requireQuantity,
          merchandiseLimitQuantity: item.merchandiseLimitQuantity
        })),
        tradeMerchandiseInfoList: formData.tradeMerchandiseInfoList.map(item => ({
          prodNo: item.prodNo,
          prodName: item.prodName,
          tradePrice: item.tradePrice,
          tradeQuantity: item.tradeQuantity
        })),
        enableSuperposition: formData.enableSuperposition,
        tradeMerchandiseQuantity: formData.tradeMerchandiseQuantity,
        merchandiseQuantity: formData.activityType === activityTypes['组合满数量赠'] ? formData.merchandiseQuantity : undefined,
        ladderRuleList: formData.activityRule === activityRuleTypes['单商品满数量自主换购'] ? formData.ladderRuleList.map((rule, index) => {
          var _formData$activityMer, _formData$activityMer2;

          return {
            level: index + 1,
            // 添加阶梯序号，从1开始
            prodNo: formData.activityType === activityTypes['全品类满金额赠'] ? undefined : (_formData$activityMer = formData.activityMerchandiseInfoList[0]) === null || _formData$activityMer === void 0 ? void 0 : _formData$activityMer.prodNo,
            prodName: formData.activityType === activityTypes['全品类满金额赠'] ? undefined : (_formData$activityMer2 = formData.activityMerchandiseInfoList[0]) === null || _formData$activityMer2 === void 0 ? void 0 : _formData$activityMer2.prodName,
            thresholdQuantityRadio: rule.thresholdQuantityRadio,
            thresholdQuantity: rule.thresholdQuantity,
            requireQuantity: rule.requireQuantity,
            merchandiseLimitQuantity: rule.merchandiseLimitQuantity,
            // 为每个规则明细添加换购商品信息
            ruleDetails: rule.ruleDetails.map((detail, index) => {
              var _formData$tradeMercha, _formData$tradeMercha2;

              return {
                prodNo: (_formData$tradeMercha = formData.tradeMerchandiseInfoList[index]) === null || _formData$tradeMercha === void 0 ? void 0 : _formData$tradeMercha.prodNo,
                prodName: (_formData$tradeMercha2 = formData.tradeMerchandiseInfoList[index]) === null || _formData$tradeMercha2 === void 0 ? void 0 : _formData$tradeMercha2.prodName,
                tradeQuantity: detail.tradeQuantity,
                tradePrice: detail.tradePrice
              };
            })
          };
        }) : undefined,
        enableRemain: formData.enableRemain,
        remainValidType: formData.enableRemain === 1 ? formData.remainValidType : 1,
        remainValidStatus: formData.enableRemain === 1 && formData.remainValidType === 2 ? formData.remainValidStatus : 1,
        remainValidEndtime: formData.enableRemain === 1 && formData.remainValidType === 2 && formData.remainValidStatus === 2 ? formData.remainValidEndtime : undefined,
        prePaymentType: formData.prePaymentType
      };

      if (formData.activityType === activityTypes['满金额赠']) {
        body.orderAmount = formData.orderAmount;
      }

      if (formData.activityType === activityTypes['组合满数量赠']) {
        body.merchandiseQuantity = formData.merchandiseQuantity;
      }

      if (formData.activityRule === activityRuleTypes['多商品任一满数量自主换购']) {
        body.tradeRule = formData.tradeRule;

        if (formData.tradeRule === 2) {
          body.tradeQuantity = formData.tradeQuantity;
        }
      }

      if (pageType === 'update' && editRemark) {
        body.editRemark = editRemark;
      }

      body.__repeat = true;
      activityBuygiveUpdate(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          if (type === 'refresh') {
            Object.assign(formData, new FormDataTpl());
            form.value.resetFields();
            ElMessage.success('提交成功，创建的活动已提交成功，请继续创建');
          } else {
            ElMessage.success(msg);
            goBack();
          }

          return true;
        }

        ElMessage.error(msg);
        return false;
      }).finally(() => {
        submitting.value = false;
      });
    }

    function resetRemainValidConfig() {
      formData.remainValidType = 1;
      formData.remainValidStatus = 1;
      formData.remainValidEndtime = undefined;
    }

    function enableRemainChangeHandle(val) {
      if (val !== 1) {
        resetRemainValidConfig();
      }
    }

    function remainValidTypeChangeHandle(val) {
      if (val !== 2) {
        formData.remainValidStatus = 1;
        formData.remainValidEndtime = undefined;
      }
    }

    function remainValidStatusChangeHandle(val) {
      if (val !== 2) {
        formData.remainValidEndtime = undefined;
      }
    }

    function remainValidEndtimeDisabledDate(date) {
      var _formData$activityTim10;

      const activityEndTime = (_formData$activityTim10 = formData.activityTimeList) === null || _formData$activityTim10 === void 0 ? void 0 : _formData$activityTim10[1];

      if (!activityEndTime) {
        return false;
      }

      return new Date(date).getTime() <= new Date(activityEndTime).getTime();
    } // 活动类型change


    function activityTypeChangeHandle() {
      form.value.clearValidate();
      /**
       * 1.活动类型选中组合满数量赠，则活动规则禁选单商品满数量自动换购
       * 2.活动类型为组合满数量赠时，选择活动商品后，商品表格内不展示活动规则列及批量设置活动规则按钮
       */

      if (formData.activityType === activityTypes['组合满数量赠']) {
        formData.activityRule = 1;
      }

      if (formData.activityType === activityTypes['全品类满金额赠']) {
        formData.activityRule = 3;
      }
    } // 批量设置


    const batchSetForm = ref();
    const submitting = ref(false);
    const editRemarkDialog = reactive({
      visible: false,
      remark: '',
      submitType: undefined
    });
    const batchSetDialog = reactive({
      visible: false,
      type: '',
      value: undefined
    });
    const batchSetRules = {
      value: [{
        required: true,
        message: '请填写批量设置参数'
      }]
    };
    const batchSetTypes = {
      活动规则: 'requireQuantity',
      门槛数量: 'thresholdQuantity',
      最大换购量: 'tradeQuantity',
      限购总数: 'merchandiseLimitQuantity',
      换购价: 'tradePrice'
    };

    function batchSetHandle(type) {
      batchSetDialog.visible = true;
      batchSetDialog.type = type;
      nextTick(() => {
        batchSetForm.value.resetFields();
        batchSetDialog.value = undefined;
      });
    }

    function batchSetSuccessHandle() {
      if (batchSetDialog.type === batchSetTypes['活动规则']) {
        formData.activityMerchandiseInfoList.forEach(item => {
          item.requireQuantity = batchSetDialog.value;
        });
      } else {
        formData.tradeMerchandiseInfoList.forEach(item => {
          item[batchSetDialog.type] = batchSetDialog.value;
        });
      }

      batchSetDialog.visible = false;
    } // 活动规则变更清空商品


    function activityRuleChangeHandle() {
      formData.activityMerchandiseInfoList = [];
      formData.tradeMerchandiseInfoList = []; // 确保 ladderRuleList 始终是数组

      if (formData.activityRule === activityRuleTypes['单商品满数量自主换购']) {
        formData.ladderRuleList = [{
          thresholdQuantityRadio: 0,
          thresholdQuantity: undefined,
          // 门槛数量-空为无门槛(主品用)
          requireQuantity: undefined,
          // 活动规则(满多少盒)
          merchandiseLimitQuantity: undefined,
          // 多换购品限购总数(主品用)
          ruleDetails: []
        }];
      } else {
        formData.ladderRuleList = []; // 改为空数组而不是 null/undefined
      }
    } // 活动商品 换购商品 搜索


    const activityMerchandiseSearch = ref('');
    const filterActivityMerchandiseInfoList = computed(() => formData.activityMerchandiseInfoList.filter(item => item.prodName.includes(activityMerchandiseSearch.value) || item.prodNo.includes(activityMerchandiseSearch.value)));
    const tradeMerchandiseSearch = ref('');
    const filterTradeMerchandiseInfoList = computed(() => formData.tradeMerchandiseInfoList.filter(item => item.prodName.includes(tradeMerchandiseSearch.value) || item.prodNo.includes(tradeMerchandiseSearch.value))); // 新增换购规则

    function addLadderRuleHandle() {
      const firstRule = formData.ladderRuleList[0];
      formData.ladderRuleList.push({
        thresholdQuantityRadio: 0,
        thresholdQuantity: undefined,
        // 门槛数量-空为无门槛(主品用)
        requireQuantity: undefined,
        // 活动规则(满多少盒)
        merchandiseLimitQuantity: undefined,
        // 多换购品限购总数(主品用)
        ruleDetails: formData.tradeMerchandiseInfoList.map((_, index) => {
          var _firstRule$ruleDetail;

          return {
            tradeQuantity: undefined,
            tradePrice: firstRule === null || firstRule === void 0 ? void 0 : (_firstRule$ruleDetail = firstRule.ruleDetails[index]) === null || _firstRule$ruleDetail === void 0 ? void 0 : _firstRule$ruleDetail.tradePrice // 继承第一阶梯的价格

          };
        })
      });
      clearValidate('ladderRuleList');
    } // 删除换购规则


    function deleteLadderRuleHandle(index) {
      // 使用行数据中的ruleIndex来删除对应的规则组
      const ruleIndex = Math.floor(index / formData.tradeMerchandiseInfoList.length);
      formData.ladderRuleList.splice(ruleIndex, 1);
      clearValidate('ladderRuleList');
    } // 修改合并行方法


    function ladderRuleSpanMethod({
      column,
      rowIndex
    }) {
      const tradeCount = formData.tradeMerchandiseInfoList.length;

      if (!tradeCount) {
        return;
      }

      const mergeProps = formData.activityType === activityTypes['全品类满金额赠'] ? ['level', 'requireQuantity', 'merchandiseLimitQuantity', 'operation'] : ['level', 'thresholdQuantity', 'requireQuantity', 'merchandiseLimitQuantity', 'operation'];

      if (!mergeProps.includes(column.property)) {
        return;
      }

      if (rowIndex % tradeCount === 0) {
        return {
          rowspan: tradeCount,
          colspan: 1
        };
      }

      return {
        rowspan: 0,
        colspan: 0
      };
    } // 添加计算属性处理表格数据


    const tableData = computed(() => {
      const data = [];
      formData.ladderRuleList.forEach((rule, ruleIndex) => {
        // 每个阶梯规则都包含所有换购商品
        formData.tradeMerchandiseInfoList.forEach((merchandise, index) => {
          var _rule$ruleDetails$ind, _rule$ruleDetails$ind2;

          data.push({
            ruleIndex,
            merchandiseIndex: index,
            level: ruleIndex + 1,
            // 添加阶梯序号，从1开始
            tradeMerchandiseNo: merchandise.prodNo,
            tradeMerchandiseName: merchandise.prodName + "/" + merchandise.prodSpecification + "(" + merchandise.erpNo + ")",
            tradeQuantity: (_rule$ruleDetails$ind = rule.ruleDetails[index]) === null || _rule$ruleDetails$ind === void 0 ? void 0 : _rule$ruleDetails$ind.tradeQuantity,
            tradePrice: (_rule$ruleDetails$ind2 = rule.ruleDetails[index]) === null || _rule$ruleDetails$ind2 === void 0 ? void 0 : _rule$ruleDetails$ind2.tradePrice,
            isFirstRow: index === 0 // 添加标记是否为规则组的第一行

          });
        });
      });
      return data;
    });

    function clearValidate(prop) {
      nextTick(() => {
        form.value.clearValidate(prop);
      });
    }

    function handleTradePriceChange(value, scope) {
      // 当第一阶梯的价格改变时，同步更新其他阶梯的价格
      if (scope.row.ruleIndex === 0) {
        const merchandiseIndex = scope.row.merchandiseIndex;
        formData.ladderRuleList.forEach((rule, ruleIndex) => {
          if (ruleIndex > 0) {
            rule.ruleDetails[merchandiseIndex].tradePrice = value;
          }
        });
      }

      clearValidate('ladderRuleList');
    }

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_divider = _resolveComponent("el-divider");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_link = _resolveComponent("el-link");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!__props.embedMode ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(pageTitle[_unref(pageType)]) + "超值换购活动", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: goBack
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: formData,
        rules: formRules,
        "label-position": "right",
        "label-width": "100px",
        class: "form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "活动名称",
          prop: "activityName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.activityName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.activityName = $event),
            placeholder: "请输入活动名称",
            style: {
              "width": "380px"
            },
            disabled: _unref(activityNameDisabled),
            maxlength: 25
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动类型",
          prop: "activityType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.activityType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.activityType = $event),
            disabled: _unref(activityTypeDisabled),
            onChange: activityTypeChangeHandle
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: activityTypes['满数量赠']
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_radio, {
              label: activityTypes['全品类满金额赠']
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        }), formData.activityType !== activityTypes['满数量赠'] && formData.activityType !== activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0
        }, {
          default: _withCtx(() => [formData.activityType === activityTypes['满金额赠'] ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_input_number, {
            modelValue: formData.orderAmount,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.orderAmount = $event),
            min: 0,
            max: 999999999,
            precision: 2,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"]), _hoisted_10])) : _createCommentVNode("", true), formData.activityType === activityTypes['组合满数量赠'] ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_input_number, {
            modelValue: formData.merchandiseQuantity,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.merchandiseQuantity = $event),
            min: 1,
            max: 999999999,
            "step-strictly": true,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"]), _hoisted_13])) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "活动时间",
          prop: "activityTimeList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_date_picker, {
            modelValue: _unref(activityStartTime),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(activityStartTime) ? activityStartTime.value = $event : null),
            type: "datetime",
            placeholder: "开始日期",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "disabled-date": activityTimeDisabledDate,
            disabled: _unref(activityStartTimeDisabled)
          }, null, 8, ["modelValue", "disabled"]), _hoisted_15, _createVNode(_component_el_date_picker, {
            modelValue: _unref(activityEndTime),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(activityEndTime) ? activityEndTime.value = $event : null),
            type: "datetime",
            placeholder: "结束日期",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "disabled-date": activityTimeDisabledDate,
            disabled: _unref(activityEndTimeDisabled)
          }, null, 8, ["modelValue", "disabled"])])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动发起方",
          prop: "supplierInfoVo"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(VanInputSelect, {
            modelValue: formData.supplierInfoVo.supplierName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.supplierInfoVo.supplierName = $event),
            disabled: _unref(updateDisabled),
            style: {
              "width": "200px"
            },
            onSelect: openSupplierModalHandle,
            onClear: supplierClearHandle
          }, null, 8, ["modelValue", "disabled"]), _unref(supplierPublisherCount) > 1 ? (_openBlock(), _createBlock(_component_el_link, {
            key: 0,
            type: "primary",
            underline: false,
            class: "supplier-publisher-count",
            onClick: openSupplierModalHandle
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(supplierPublisherCount)) + "个团队", 1)]),
            _: 1
          })) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "选择发货方",
          prop: "branchInfoVo"
        }, {
          default: _withCtx(() => [_createVNode(VanInputSelect, {
            modelValue: formData.branchInfoVo.branchName,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.branchInfoVo.branchName = $event),
            disabled: _unref(branchDisabled),
            style: {
              "width": "200px"
            },
            onSelect: selectBranchHandle,
            onClear: branchClearHandle
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), formData.activityType === activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "活动商品范围",
          prop: "selectMerchandiseType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.selectMerchandiseType,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.selectMerchandiseType = $event),
            disabled: _unref(selectMerchandiseTypeDisabled),
            onChange: selectMerchandiseTypeChangeHandle
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_17]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_18]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), formData.activityType !== activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: "活动规则",
          prop: "activityRule"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.activityRule,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.activityRule = $event),
            disabled: _unref(activityRuleDisabled),
            onChange: activityRuleChangeHandle,
            class: "vertical-radio-group"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_radio, {
              label: activityRuleTypes['单商品满数量自主换购']
            }, {
              default: _withCtx(() => [_hoisted_19, _hoisted_20]),
              _: 1
            }, 8, ["label"]), [[_vShow, formData.activityType === activityTypes['满数量赠']]]), _withDirectives(_createVNode(_component_el_radio, {
              label: activityRuleTypes['单商品满数量自动换购']
            }, {
              default: _withCtx(() => [_hoisted_21, _hoisted_22]),
              _: 1
            }, 8, ["label"]), [[_vShow, formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['满金额赠']]]), _createVNode(_component_el_radio, {
              label: activityRuleTypes['多商品任一满数量自主换购']
            }, {
              default: _withCtx(() => [_hoisted_23, _hoisted_24]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), formData.activityType === activityTypes['全品类满金额赠'] && formData.selectMerchandiseType === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          label: "活动商品"
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_form_item, {
          key: 4,
          label: "活动商品",
          prop: "activityMerchandiseInfoList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_unref(updateDisabled) === false ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_button, {
            onClick: _cache[10] || (_cache[10] = $event => addMerchandiseHandle('activityMerchandiseInfoList'))
          }, {
            default: _withCtx(() => [_hoisted_29]),
            _: 1
          }), formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] && formData.activityMerchandiseInfoList.length ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            modelValue: activityMerchandiseSearch.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => activityMerchandiseSearch.value = $event),
            placeholder: "搜索商品",
            style: {
              "width": "240px"
            }
          }, {
            append: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "search"
            })]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true)]), formData.activityMerchandiseInfoList.length && formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] && formData.activityType === activityTypes['满数量赠'] ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[12] || (_cache[12] = $event => batchSetHandle(batchSetTypes['活动规则']))
          }, {
            default: _withCtx(() => [_hoisted_30]),
            _: 1
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), formData.activityMerchandiseInfoList.length ? (_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: _unref(filterActivityMerchandiseInfoList),
            border: "",
            class: "simple-table",
            maxHeight: "300px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "prodNo",
              label: "药品编码",
              width: "200"
            }), _createVNode(_component_el_table_column, {
              prop: "prodName",
              label: "药品名称",
              width: "160"
            }), _createVNode(_component_el_table_column, {
              prop: "prodSpecification",
              label: "药品规格",
              width: "200"
            }), formData.activityType === activityTypes['满数量赠'] && formData.activityRule !== activityRuleTypes['单商品满数量自主换购'] ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "prodNo",
              label: "活动规则",
              width: "220"
            }, {
              default: _withCtx(scope => [_hoisted_31, _createVNode(_component_el_input_number, {
                modelValue: scope.row.requireQuantity,
                "onUpdate:modelValue": $event => scope.row.requireQuantity = $event,
                min: 1,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled),
                style: {
                  "margin": "0 8px"
                },
                onChange: _cache[13] || (_cache[13] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_32]),
              _: 1
            })) : _createCommentVNode("", true), _unref(updateDisabled) === false ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "prodNo",
              label: "操作",
              width: "80"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: $event => deleteMerchandiseHandle('activityMerchandiseInfoList', scope)
              }, {
                default: _withCtx(() => [_hoisted_33]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true), formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] && formData.activityMerchandiseInfoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 已添加" + _toDisplayString(formData.activityMerchandiseInfoList.length) + "个商品，最大数量不超过1000个 ", 1)) : _createCommentVNode("", true)])]),
          _: 1
        })), _createVNode(_component_el_form_item, {
          label: "换购商品",
          prop: "tradeMerchandiseInfoList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_unref(updateDisabled) === false ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[14] || (_cache[14] = $event => addMerchandiseHandle('tradeMerchandiseInfoList'))
          }, {
            default: _withCtx(() => [_hoisted_38]),
            _: 1
          })) : _createCommentVNode("", true), formData.tradeMerchandiseInfoList.length && _unref(updateDisabled) === false ? (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            modelValue: tradeMerchandiseSearch.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => tradeMerchandiseSearch.value = $event),
            placeholder: "搜索商品",
            style: {
              "width": "240px"
            }
          }, {
            append: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "search"
            })]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true), formData.activityType !== activityTypes['满金额赠'] && formData.activityRule === activityRuleTypes['单商品满数量自动换购'] && formData.tradeMerchandiseInfoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_hoisted_40, _createVNode(_component_el_radio_group, {
            modelValue: formData.enableSuperposition,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => formData.enableSuperposition = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_41]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_42]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true)]), formData.activityRule !== activityRuleTypes['单商品满数量自主换购'] && formData.tradeMerchandiseInfoList.length && _unref(updateDisabled) === false ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = $event => batchSetHandle(batchSetTypes['换购价']))
          }, {
            default: _withCtx(() => [_hoisted_44]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = $event => batchSetHandle(batchSetTypes['最大换购量']))
          }, {
            default: _withCtx(() => [_createTextVNode(" 批量设置" + _toDisplayString(formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] ? '最大' : '固定') + "换购量 ", 1)]),
            _: 1
          })])) : _createCommentVNode("", true)]), formData.tradeMerchandiseInfoList.length ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: _unref(filterTradeMerchandiseInfoList),
            border: "",
            class: "simple-table",
            maxHeight: "300px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "prodNo",
              label: "药品编码",
              width: "200"
            }), _createVNode(_component_el_table_column, {
              prop: "prodName",
              label: "药品名称",
              width: "160"
            }), _createVNode(_component_el_table_column, {
              prop: "prodSpecification",
              label: "药品规格",
              width: "200"
            }), formData.activityRule !== activityRuleTypes['单商品满数量自主换购'] ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "prodNo",
              label: "换购价",
              width: "200"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.tradePrice,
                "onUpdate:modelValue": $event => scope.row.tradePrice = $event,
                min: 0,
                max: 999999999,
                precision: 2,
                disabled: _unref(updateDisabled),
                style: {
                  "margin-right": "8px"
                },
                onChange: _cache[19] || (_cache[19] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_45]),
              _: 1
            })) : _createCommentVNode("", true), formData.activityRule !== activityRuleTypes['单商品满数量自主换购'] ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "prodNo",
              label: `${formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] ? '最大' : '固定'}换购数量`,
              width: "200"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.tradeQuantity,
                "onUpdate:modelValue": $event => scope.row.tradeQuantity = $event,
                min: 1,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled),
                style: {
                  "margin-right": "8px"
                },
                onChange: _cache[20] || (_cache[20] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_46]),
              _: 1
            }, 8, ["label"])) : _createCommentVNode("", true), _unref(updateDisabled) === false ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "prodNo",
              label: "操作",
              width: "80"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: $event => deleteMerchandiseHandle('tradeMerchandiseInfoList', scope)
              }, {
                default: _withCtx(() => [_hoisted_47]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true), formData.tradeMerchandiseInfoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 已添加" + _toDisplayString(formData.tradeMerchandiseInfoList.length) + "个商品，最大数量不超过" + _toDisplayString(formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] ? '1000' : '50') + "个 ", 1)) : _createCommentVNode("", true)])]),
          _: 1
        }), formData.activityType === activityTypes['满金额赠'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 5,
          label: "换购规则",
          prop: "ladderRuleList",
          class: "ladder-rule-form-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createVNode(_component_el_radio_group, {
            modelValue: formData.enableSuperposition,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => formData.enableSuperposition = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_53]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_54, _hoisted_55]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])])])])])]),
          _: 1
        })) : _createCommentVNode("", true), formData.activityRule === activityRuleTypes['单商品满数量自主换购'] && formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 6,
          label: "换购规则",
          prop: "ladderRuleList",
          class: "ladder-rule-form-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_el_radio_group, {
            modelValue: formData.enableRemain,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => formData.enableRemain = $event),
            disabled: _unref(enableRemainDisabled),
            onChange: enableRemainChangeHandle,
            class: "enable-remain-radio-group"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_60]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_61]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"]), _createElementVNode("span", _hoisted_62, [_hoisted_63, _hoisted_64, _createVNode(_component_el_radio_group, {
            modelValue: formData.remainValidType,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => formData.remainValidType = $event),
            disabled: _unref(updateDisabled),
            onChange: remainValidTypeChangeHandle,
            class: "remain-valid-type-group"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_65]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2,
              class: "remain-valid-yes-radio"
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_66, [_hoisted_67, _createVNode(_component_el_select, {
                modelValue: formData.remainValidStatus,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => formData.remainValidStatus = $event),
                disabled: _unref(updateDisabled) || formData.remainValidType !== 2,
                placeholder: "请选择效期",
                style: {
                  "width": "160px"
                },
                onChange: remainValidStatusChangeHandle,
                onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  value: 1,
                  label: "长期有效"
                }), _createVNode(_component_el_option, {
                  value: 2,
                  label: "自定义截止时间"
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"]), _createVNode(_component_el_date_picker, {
                modelValue: formData.remainValidEndtime,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => formData.remainValidEndtime = $event),
                type: "datetime",
                placeholder: "请选择截止时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                "disabled-date": remainValidEndtimeDisabledDate,
                disabled: _unref(updateDisabled) || formData.remainValidType !== 2 || formData.remainValidStatus !== 2,
                style: {
                  "width": "220px"
                },
                onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, ["modelValue", "disabled"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"]), _hoisted_68]), _hoisted_69]), _createElementVNode("div", _hoisted_70, [_createVNode(_component_el_radio_group, {
            modelValue: formData.enableSuperposition,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => formData.enableSuperposition = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_71]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_72, _hoisted_73]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])]), formData.activityType === activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            "true-label": 1,
            "false-label": 0,
            modelValue: formData.enableUnCalculate,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => formData.enableUnCalculate = $event),
            disabled: ""
          }, {
            default: _withCtx(() => [_hoisted_74]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true)]), formData.activityType === activityTypes['全品类满金额赠'] ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_hoisted_76, _createVNode(_component_el_radio_group, {
            modelValue: formData.prePaymentType,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => formData.prePaymentType = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_77]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_78]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_79, [_createElementVNode("span", null, _toDisplayString(formData.tradeMerchandiseInfoList.length) + "选", 1), _createVNode(_component_el_input_number, {
            modelValue: formData.tradeMerchandiseQuantity,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => formData.tradeMerchandiseQuantity = $event),
            min: 0,
            max: formData.tradeMerchandiseInfoList.length,
            "step-strictly": true,
            disabled: _unref(updateDisabled),
            style: {
              "margin": "0 8px"
            },
            onChange: _cache[32] || (_cache[32] = $event => clearValidate('ladderRuleList'))
          }, null, 8, ["modelValue", "max", "disabled"]), _hoisted_80])]), Array.isArray(formData.ladderRuleList) && formData.ladderRuleList.length ? (_openBlock(), _createBlock(_component_el_table, {
            key: `${formData.tradeMerchandiseInfoList.length}-${formData.ladderRuleList.length}`,
            data: _unref(tableData),
            border: "",
            class: "simple-table",
            style: {
              "overflow-x": "auto"
            },
            "span-method": ladderRuleSpanMethod
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "level",
              label: "阶梯序号",
              width: "100"
            }, {
              default: _withCtx(scope => [scope.$index % formData.tradeMerchandiseInfoList.length === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_81, [_hoisted_82, _createElementVNode("span", _hoisted_83, _toDisplayString(scope.row.ruleIndex + 1), 1), _hoisted_84])) : _createCommentVNode("", true)]),
              _: 1
            }), formData.activityType !== activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "thresholdQuantity",
              label: "活动采购门槛",
              width: "240"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
                style: {
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "flex-start"
                },
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].thresholdQuantityRadio,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].thresholdQuantityRadio = $event
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 0
                }, {
                  default: _withCtx(() => [_hoisted_86]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [_hoisted_87]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", null, [_hoisted_88, _createVNode(_component_el_input_number, {
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].thresholdQuantity,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].thresholdQuantity = $event,
                min: 1,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled),
                style: {
                  "margin": "0 8px"
                },
                onChange: _cache[33] || (_cache[33] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_89])])]),
              _: 1
            })) : _createCommentVNode("", true), formData.activityType !== activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "requireQuantity",
              label: "活动商品",
              width: "220"
            }, {
              default: _withCtx(scope => [_hoisted_90, _createVNode(_component_el_input_number, {
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].requireQuantity,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].requireQuantity = $event,
                min: 1,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled),
                style: {
                  "margin": "0 8px"
                },
                onChange: _cache[34] || (_cache[34] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_91]),
              _: 1
            })) : _createCommentVNode("", true), formData.activityType === activityTypes['全品类满金额赠'] ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "requireQuantity",
              label: "金额门槛",
              width: "220"
            }, {
              default: _withCtx(scope => [_hoisted_92, _createVNode(_component_el_input_number, {
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].requireQuantity,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].requireQuantity = $event,
                min: 1,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled),
                style: {
                  "margin": "0 8px"
                },
                onChange: _cache[35] || (_cache[35] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_93]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              prop: "tradeMerchandiseName",
              label: "换购/搭配商品",
              width: "160"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.tradeMerchandiseName), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "tradeQuantity",
              label: "最大换购/搭配数量",
              width: "220"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].ruleDetails[scope.row.merchandiseIndex].tradeQuantity,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].ruleDetails[scope.row.merchandiseIndex].tradeQuantity = $event,
                min: 0,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled),
                style: {
                  "margin-right": "8px"
                },
                onChange: _cache[36] || (_cache[36] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_94]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "merchandiseLimitQuantity",
              label: "多换购品限购总数",
              width: "220"
            }, {
              default: _withCtx(scope => [_hoisted_95, _createVNode(_component_el_input_number, {
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].merchandiseLimitQuantity,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].merchandiseLimitQuantity = $event,
                min: 1,
                max: 999999999,
                "step-strictly": true,
                disabled: _unref(updateDisabled) || formData.tradeMerchandiseInfoList.length <= 1,
                style: {
                  "margin": "0 8px"
                },
                onChange: _cache[37] || (_cache[37] = $event => clearValidate('ladderRuleList'))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _hoisted_96]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "tradePrice",
              label: "换购/搭配金额",
              width: "200"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: formData.ladderRuleList[scope.row.ruleIndex].ruleDetails[scope.row.merchandiseIndex].tradePrice,
                "onUpdate:modelValue": $event => formData.ladderRuleList[scope.row.ruleIndex].ruleDetails[scope.row.merchandiseIndex].tradePrice = $event,
                min: 0,
                max: 999999999,
                precision: 2,
                disabled: _unref(updateDisabled) || scope.row.ruleIndex > 0,
                style: {
                  "margin-right": "8px"
                },
                onChange: value => handleTradePriceChange(value, scope)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]), _hoisted_97]),
              _: 1
            }), _unref(updateDisabled) === false ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "operation",
              label: "操作",
              width: "160"
            }, {
              default: _withCtx(scope => [scope.row.ruleIndex === 0 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                onClick: addLadderRuleHandle
              }, {
                default: _withCtx(() => [_hoisted_98]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "danger",
                size: "small",
                onClick: $event => deleteLadderRuleHandle(scope.$index)
              }, {
                default: _withCtx(() => [_hoisted_99]),
                _: 2
              }, 1032, ["onClick"]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true)])]),
          _: 1
        })) : _createCommentVNode("", true), formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 7,
          label: "换购规则",
          prop: "tradeRule"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: formData.tradeRule,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => formData.tradeRule = $event),
            disabled: _unref(updateDisabled)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_100]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_101]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"]), formData.tradeRule === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_hoisted_103, _createVNode(_component_el_input_number, {
            modelValue: formData.tradeQuantity,
            "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => formData.tradeQuantity = $event),
            min: 0,
            max: formData.tradeMerchandiseInfoList.length,
            "step-strictly": true,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "max", "disabled"]), _hoisted_104])) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])]), !_unref(updateDisabled) ? (_openBlock(), _createElementBlock("div", _hoisted_105, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [_hoisted_106]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        loading: submitting.value,
        disabled: submitting.value,
        onClick: _cache[40] || (_cache[40] = $event => submit('refresh'))
      }, {
        default: _withCtx(() => [_hoisted_107]),
        _: 1
      }, 8, ["loading", "disabled"]), _createVNode(_component_el_button, {
        type: "primary",
        loading: submitting.value,
        disabled: submitting.value,
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_108]),
        _: 1
      }, 8, ["loading", "disabled"])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: batchSetDialog.visible,
        "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => batchSetDialog.visible = $event),
        title: "批量设置"
      }, {
        footer: _withCtx(() => [_createElementVNode("footer", _hoisted_112, [_createVNode(_component_el_button, {
          onClick: _cache[44] || (_cache[44] = $event => batchSetDialog.visible = false)
        }, {
          default: _withCtx(() => [_hoisted_113]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: batchSetSuccessHandle
        }, {
          default: _withCtx(() => [_hoisted_114]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "batchSetForm",
          ref: batchSetForm,
          model: batchSetDialog,
          rules: batchSetRules,
          "label-position": "right",
          "label-width": "160px"
        }, {
          default: _withCtx(() => [batchSetDialog.type === batchSetTypes['活动规则'] ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "批量设置活动规则",
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: batchSetDialog.value,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => batchSetDialog.value = $event),
              min: 1,
              max: 999999999,
              "step-strictly": true,
              style: {
                "margin-right": "8px"
              }
            }, null, 8, ["modelValue"]), _hoisted_109]),
            _: 1
          })) : _createCommentVNode("", true), batchSetDialog.type === batchSetTypes['最大换购量'] ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: '批量设置' + (formData.activityRule === activityRuleTypes['多商品任一满数量自主换购'] ? '最大' : '定') + '换购量',
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: batchSetDialog.value,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => batchSetDialog.value = $event),
              min: 1,
              max: 999999999,
              "step-strictly": true,
              style: {
                "margin-right": "8px"
              }
            }, null, 8, ["modelValue"]), _hoisted_110]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), batchSetDialog.type === batchSetTypes['换购价'] ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "批量设置换购价",
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: batchSetDialog.value,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => batchSetDialog.value = $event),
              min: 0,
              max: 999999999,
              precision: 2,
              style: {
                "margin-right": "8px"
              }
            }, null, 8, ["modelValue"]), _hoisted_111]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(BranchModal, {
        modelValue: branchModal.visible,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => branchModal.visible = $event),
        supplierId: formData.supplierInfoVo.supplierId,
        onSuccess: selectBranchSuccessHandle
      }, null, 8, ["modelValue", "supplierId"]), _createVNode(SupplierModal, {
        modelValue: supplierModal.visible,
        "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => supplierModal.visible = $event),
        selectedSupplierIds: supplierModal.selectedSupplierIds,
        filterSupplierIds: _unref(updateDisabled) ? _unref(supplierFilterIds) : '',
        viewOnly: _unref(updateDisabled),
        checkType: formData.activityType === activityTypes['满数量赠'] || formData.activityType === activityTypes['全品类满金额赠'] ? 'checkbox' : 'radio',
        onSuccess: selectSupplierSuccessHandle
      }, null, 8, ["modelValue", "selectedSupplierIds", "filterSupplierIds", "viewOnly", "checkType"]), _createVNode(MerchandiseModal, {
        modelValue: merchandiseModal.visible,
        "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => merchandiseModal.visible = $event),
        branchId: formData.branchInfoVo.branchId,
        supplierIds: formData.supplierInfoVo.supplierId,
        checkType: _unref(merchandiseModalCheckType),
        selectedList: formData.selectMerchandiseProdNos,
        onSuccess: selectMerchandiseSuccessHandle
      }, null, 8, ["modelValue", "branchId", "supplierIds", "checkType", "selectedList"]), _createVNode(_component_el_dialog, {
        modelValue: editRemarkDialog.visible,
        "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => editRemarkDialog.visible = $event),
        title: "活动更新备注",
        width: "480px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[50] || (_cache[50] = $event => editRemarkDialog.visible = false)
        }, {
          default: _withCtx(() => [_hoisted_115]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: submitting.value,
          disabled: submitting.value,
          onClick: confirmEditRemarkSubmit
        }, {
          default: _withCtx(() => [_hoisted_116]),
          _: 1
        }, 8, ["loading", "disabled"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: editRemarkDialog.remark,
          "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => editRemarkDialog.remark = $event),
          type: "textarea",
          rows: 4,
          maxlength: 255,
          "show-word-limit": "",
          placeholder: "请输入本次活动更新备注"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }

};